import $ from "jquery";

$(".js-poll-form").each(function (index) {
  const pollEl = $(this);
  const pollFormEl = $(this).find("form");
  const pollSubmitEl = pollFormEl.find(".btn[type=submit]");

  pollSubmitEl.on("click", (e) => {
    e.preventDefault();

    submitPoll(pollEl, pollFormEl);
  });
});

function submitPoll(pollContainer: HTMLElement, poll: HTMLFormElement) {
  if ($(poll).valid()) {
    $.ajax({
      cache: false,
      data: $(poll).serialize(),
      type: "POST",
      url: $(poll).attr("action"),
      success(result) {
        getPollResults(pollContainer, poll);
      },
    });
  }
}

function getPollResults(pollContainer: HTMLElement, poll: HTMLFormElement) {
  const formId = $(poll).find("input[name=FormId]").val();

  $.ajax({
    cache: false,
    data: $(poll).serialize(),
    type: "GET",
    url: "/umbraco/surface/Polls/GetResults?formId=" + formId,
    success(result) {
      const pollResults = $("#" + formId + "-results");
      const pollResultsContainer = $("#" + formId + "-results-container");

      $.each(result.results, (i, val) => {
        pollResults.append(
          '<div class="poll-block__result"><span class="poll-block__option"><span class="poll-block__option-name">' +
            i +
            '</span><span class="poll-block__option-value">' +
            Math.round(val) +
            '%</span></span><span class="poll-block__bar"><span class="poll-block__bar-value" style="width:' +
            Math.round(val) +
            '%;"></span></span></div>',
        );
      });
      pollResultsContainer
        .find(".js-poll-total")
        .html(result.totalNumberOfVotes);

      $(pollContainer).slideUp("slow", () => {
        pollResultsContainer.slideDown("slow", () => {
          pollResults.addClass("visible");
        });
      });
    },
  });
}
